import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebookF,
  faInstagram,
  faTwitter,
  faYoutube
} from '@fortawesome/free-brands-svg-icons';

import '../css/footer.css';

function Footer(props) {
  return (
    <footer id='footer' className={`${props.showMenu ? 'absolute' : ''}`}>
      <Container>
        <Row className='icon-row'>
          <Col className='icon-col' xs='3'>
            <a
              target='_blank'
              rel='noopener noreferrer'
              href='https://www.facebook.com/iamjamiesparker/'
            >
              <FontAwesomeIcon icon={faFacebookF} />
            </a>
          </Col>
          <Col className='icon-col' xs='3'>
            <a
              target='_blank'
              rel='noopener noreferrer'
              href='https://www.instagram.com/iamjamiesparker/?fbclid=IwAR36iAT9dbqY3Ccr76_RAjoAIkMX9aFPr0cULDbKIZc-C0Z02VorR0XUHsI'
            >
              <FontAwesomeIcon icon={faInstagram} />
            </a>
          </Col>
          <Col className='icon-col' xs='3'>
            <a
              target='_blank'
              rel='noopener noreferrer'
              href='https://twitter.com/iamjamiesparker?fbclid=IwAR0zCUOBcYAq39QcvpIHKzig29ooxW1r8RLbk_wQVariIM28bEIde-4iTjk'
            >
              <FontAwesomeIcon icon={faTwitter} />
            </a>
          </Col>
          <Col className='icon-col' xs='3'>
            <a
              target='_blank'
              rel='noopener noreferrer'
              href='https://www.youtube.com/channel/UCw4faacwR852iFqPTHNE3-g'
            >
              <FontAwesomeIcon icon={faYoutube} />
            </a>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
